// extracted by mini-css-extract-plugin
module.exports = {"container":"dv-z","creativeContainer":"ev-z","copy":"fv-z","cta":"gv-z","disabled":"hv-z","flipped":"iv-z","card":"jv-z"};